import { global_hooks } from './globals';

import './main.scss';
import 'assets/icomoon/style.css'; // icomoon

import 'elementor/custom_widgets/init';

import 'components/admin_bar/init';
import 'components/retina/init';
import 'components/header_sticky/init';
import 'components/footer_sticky_cta/init';
import 'components/nav_menu/init';
import 'components/mega_menu/init';
import 'components/slide_menu/init';
import 'components/carousel/init';
import 'components/carousel_mobile/init';
import 'components/forms/init';
import 'components/form_steps/init';
import 'components/scroll_to_top/init';
import 'components/toggle_height/init';

import 'modules/search/search_popup/init';

// import 'components/toggle_parent/init';
// import 'components/cookie_consent/init';

document.addEventListener('DOMContentLoaded', init);

function init() {
	console.log('main/init');

	global_hooks.do('before_init');

	if (ff.is_elementor_edit) return;

	global_hooks.do('init');

	global_hooks.do('after_init');
}
